import React, { Component } from "react"
import { ProjectName } from '../../variables/DigmaDef'
import { meritalStatus, teamMembers, familyProgramStatus, oneTill12plus, 
        one2five, noYesOther, noYesWasInPast, snapshotPhase } from '../../variables/ComboValues'
import { InputF, TextareaF, SelectF } from '../../elements/FormFields'
import { updateElement } from "../Tree/Utils.js"
import { CalendarDay2 } from '../../elements/DayPicker/DayPicker2'


export const  PImicroLegend = {
  program_date : "ת. הצטרפות לתכנית",
  program_end_data1_date: "שלב קליטת נתונים",
  program_end_date: "ת. סיום התכנית",
  program_status : "סטטוס משפחה בתכנית",
  intake_family_name : "שם משפחה",
  intake_family_woman_name : "שם האשה",
  intake_family_man_name : "שם הגבר",
  mertial_status : "סטטוס זוגיות",
  mertial_status_comment: 'הערה לסטטוס זוגיות',
  kids_number : "מס. ילדים",
  young_kid_age : "גיל הצעיר",
  eldest_kid_age : "גיל המבוגר",
  family_in_revaha : "לקוחת רווחה",
  family_revaha_intense: "אינטנסיביות העזרה",
  intake_yahav_member : "מלווה "+ ProjectName,
  family_address : "כתובת (רחוב ומספר)",
  family_town : "עיר",
  family_zipcode : "מיקוד",
  family_phone : "טלפון בבית",
  man_cellphone : "נייד גבר",
  woman_cellphone : "נייד אשה",
  other_programs : "השתתפה בתוכניות אחרות",
  other_programs_list : "באילו תכניות השתתפה?",
  // al below available - not in use
  intake_status	: "סטטוס אינטייק", 
  referral_code : "",
  intake_code : "",
  program_code : ""
}

export class FamilyContact extends Component {

    constructor(props) {
      super(props)
      this.state = { 
        products: this.props.data,
        modified: false
      }
      // this.onSaveTable = this.onSaveTable.bind(this)
      // this.handleProductTable = this.handleProductTable.bind(this)
    }
    handleProductTableDate = (day, key)  => {
      var newp = Object.assign(this.state.products)
      newp[key] = day
      this.setState({products:newp})
    }
    handleProductTable = (evt) => {
        evt.preventDefault()
        var newp= updateElement(evt, this.state.products)
        this.setState({products:newp, modified:true})
    }
   
    // update data base
    onSaveTable = (evt) => {
      evt.preventDefault()
      const { save2DB, subTableId, familyPostId, inUpdate, mbouser } = this.props
      // console.log("Family General save table: products", this.state.products)
      save2DB(familyPostId, this.state.products, subTableId, "group", inUpdate, mbouser )
      this.setState({modified:false})
      this.props.mteamMember(this.props.data.intake_yahav_member, this.state.products) // modify team memeber if needed for sorting
    }
    render() {
      const {tableTitle} = this.props
      
      return (
          <ProductTable 
            onProductTableUpdate={this.handleProductTable}
            onSaveTable={this.onSaveTable} 
            tableTitle = {tableTitle} 
            products={this.state.products} 
            modified = {this.state.modified}
            onProductTableDate={this.handleProductTableDate}
          />
      )
    }
  }
   
  class ProductTable extends Component {
    constructor(props){
        super(props)
        this.state={
            filterText : ""
        }
    }
    
    handleUserInput(filterText) {
        this.setState({filterText: filterText});
    }
    render() {
      const { onProductTableUpdate, products, tableTitle, onSaveTable, modified, onProductTableDate } = this.props
      var buttonStyle = modified ? {marginRight: '0', color: 'red'} : {marginRight: '0'}
      // console.log("General - products", products)
  
      const product = products
      const cellData=[{
            type: "text",
            name: "intake_family_name",
            value: product.intake_family_name,
            id: product.id,
            style: {width: "120px"},
            edit: true
          },{
            type: "text",
            name: "intake_family_woman_name",
            value: product.intake_family_woman_name,
            id: product.id,
            style: {width: "120px"},
            edit: true
          },{
            type: "text",
            name: "intake_family_man_name",
            value: product.intake_family_man_name,
            id: product.id,
            style: {width: "120px"},
            edit: true
          },{
            type: "select",
            options: meritalStatus,
            name: "mertial_status",
            value: product.mertial_status,
            id: product.id,
            style: {width: "120px"},
            edit: true
          },{
            type: "text",
            name: "mertial_status_comment",
            value: product.mertial_status_comment,
            id: product.id,
            style: {width: "160px"},
            edit: true
          },{
            type: "select",
            options: oneTill12plus, // ["0","1","2","3","4","5","6","7","8","9","10","11","12+"],
            name: "kids_number",
            value: product.kids_number,
            id: product.id,
            style: {width: "80px"},
            edit: true
          },{
            type: "text",
            name: "young_kid_age",
            value: product.young_kid_age,
            id: product.id,
            style: {width: "80px"},
            edit: true
          },{
            type: "text",
            name: "eldest_kid_age",
            value: product.eldest_kid_age,
            id: product.id,
            style: {width: "80px"},
            edit: true
          },{ 
            newsection: "בתכנית",
            type: "date", // text
            name: "program_date",
            value: product.program_date,
            id: product.id,
            style: {width: "130px"},
            edit: true
          },{ 
            type: "select",
            options: snapshotPhase, // ["בהצטרפות לתכנית", "תמונת מצב התחלה", "תמונת מצב אמצע", "תמונת מצב סיום"],
            name: "program_end_data1_date",
            value: product.program_end_data1_date,
            id: product.id,
            style: {width: "150px"},
            edit: true
          },{
            type: "select",
            options: teamMembers,
            name: "intake_yahav_member",
            value: product.intake_yahav_member,
            id: product.id,
            style: {width: "100px"},
            edit: true
          },{
            type: "select",
            options: familyProgramStatus, // ["בתכנית","בוגרת","מסיימת לפני הזמן בהסכמה","פורשת", "אחר"],
            name: "program_status",
            value: product.program_status,
            id: product.id,
            style: {width: "150px"},
            edit: true
          },{ 
            type: "date",
            name: "program_end_date",
            value: product.program_end_date,
            id: product.id,
            style: {width: "130px"},
            placeholder: 'dd/mm/yyyy',
            edit: true
          },{
            newsection: "כתובת וטלפונים",
            type: "text",
            name: "family_address",
            value: product.family_address,
            id: product.id,
            style: {width: "100px"},
            edit: true
          },{
            type: "text",
            name: "family_town",
            value: product.family_town,
            id: product.id,
            style: {width: "100px"},
            edit: true
          },{
            type: "text",
            name: "family_zipcode",
            value: product.family_zipcode,
            id: product.id,
            style: {width: "100px"},
            edit: true
          },{
            type: "text",
            name: "family_phone",
            value: product.family_phone,
            id: product.id,
            style: {width: "100px"},
            edit: true
          },{
            type: "text",
            name: "woman_cellphone",
            value: product.woman_cellphone,
            id: product.id,
            style: {width: "100px"},
            edit: true
          },{
            type: "text",
            name: "man_cellphone",
            value: product.man_cellphone,
            id: product.id,
            style: {width: "100px"},
            edit: true
          },{
            newsection: "רווחה ותכניות אחרות",
            type: "select",
            options: noYesWasInPast, // ["לא","כן","היתה בעבר"],
            name: "family_in_revaha",
            value: product.family_in_revaha,
            id: product.id,
            style: {width: "80px"},
            edit: true
          },{
            type: "select",
            options: one2five, // ["1- כמעט ולא","2","3","4","5- הרבה מאוד"],
            name: "family_revaha_intense",
            value: product.family_revaha_intense,
            id: product.id,
            style: {width: "80px"},
            edit: true
          },{
            type: "select",
            options: noYesOther, // ["לא","כן","אחר"],
            name: "other_programs",
            value: product.other_programs,
            id: product.id,
            style: {width: "80px"},
            edit: true
          },{
            type: "textarea",
            name: "other_programs_list",
            value: product.other_programs_list,
            id: product.id,
            style: {width: "300px"},
            edit: true
          }] 
         
      return (
        <div className="sub-tab">
            <h2 className="sub-tab-title">{tableTitle}</h2>
            
            <button style={buttonStyle} type="button"  className="btn btn-success pull-left update-button" onClick={onSaveTable}>עדכון</button>
            
            <div className="mynewdivform width1140 family-program-info" >
                <ProductRow 
                    onProductTableUpdate={onProductTableUpdate} 
                    onProductTableDate = { onProductTableDate}
                    product={product} 
                    cd={cellData}
                    />
            </div>
        </div>
      )
    }
  }

class ProductRow extends React.PureComponent {
    
    render() {
      const {onProductTableUpdate, cd, onProductTableDate} = this.props
      var key = 0;
      return (
        <div className="eachRow">
          {cd.map(cellInfo => {
              if (cellInfo.newsection !== undefined)
                return(
                <React.Fragment key={key++}>
                  <h3 key={key++} >{cellInfo.newsection}</h3>
                  <EditableFormCell key={key++} onProductTableUpdate={onProductTableUpdate} onProductTableDate={onProductTableDate} cellData={cellInfo} />
                </React.Fragment>
                )
              return (<EditableFormCell key={key++} onProductTableUpdate={onProductTableUpdate} onProductTableDate={onProductTableDate} cellData={cellInfo} /> )
          })}
  
        </div>
      )
  
    }
  
  }

  class EditableFormCell extends React.Component {
    handleChange = changeEvent => {
      this.setState({date: changeEvent.target.value})
      //this.props.onChange(changeEvent)
    }
    
    render() {
        const tp = this.props
        const tpc = tp.cellData
        if (tpc.type === "date"){
          return (
             <div className="form-cell-box-inline">
               <label htmlFor={tpc.id}>{PImicroLegend[tpc.name]}</label>
               {<CalendarDay2
                   tpc = {tpc}
                   value = {tpc.value}
                   selected={new Date()}
                   onChange={this.handleChange}
                   handleChangeDate={tp.onProductTableDate} // {this.handleChangeDate}
               />}
             </div>
           )
        }
        if (tpc.type === "select"){
          return(
            <div className="form-cell-box-inline" >
              <label  htmlFor={tpc.id}>{PImicroLegend[tpc.name]}</label><br />
              <SelectF tp={tp} tpc={tpc}  />
            </div>
          )
        }
        if (tpc.type === "textarea"){
          return(
            <div className="form-cell-box-inline">
              <label  htmlFor={tpc.id}>{PImicroLegend[tpc.name]}</label><br />
              <TextareaF tpc={tpc} tp={tp} />
            </div>
          )
        }
        return (
            <div className="form-cell-box-inline">
              <label  htmlFor={tpc.id}>{PImicroLegend[tpc.name]}</label><br />
              <InputF tpc={tpc} tp={tp} />
            </div>
        )
    }
  }
